<template>
  <div v-show="!isHidden">
    <v-btn
      icon
      class="together"
      @click="pageOne"
      :disabled="!hasPrev"
      :color="entityConfig.primaryColor"
    >
      <v-icon>mdi-chevron-double-left</v-icon>
    </v-btn>
    <v-btn
      icon
      small
      class="mr-2 together"
      @click="prev"
      :disabled="!hasPrev"
      :color="entityConfig.primaryColor"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="mr-2 together" :style="`fon-size: 1.1em; color: ${entityConfig.primaryColor}`">{{pageNumber}}</span>
    <v-btn
      icon
      small
      @click="next"
      class="together"
      :disabled="!hasNext"
      :color="entityConfig.primaryColor"
    >
      <v-icon>mdi-arrow-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    hasNext: {
      default: false,
      type: Boolean,
    },
    hasPrev: {
      default: false,
      type: Boolean,
    },
    pageNumber: {
      default: 1,
      type: Number
    }
  },
  data: () => ({
    entityConfig: {},
  }),
  methods: {
    next() {
      this.$emit("next");
    },
    prev() {
      this.$emit("prev");
    },
    pageOne() {
      this.$emit("pageone");
    }
  },
  computed: {
    isHidden() {
      return !this.hasNext && this.pageNumber == 1;
    }
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
  },
};
</script>

<style scoped>
.together {
  min-width: 0 !important;
  padding: 0px 8px !important;
}
</style>
